<template>
        <section class="container mx-auto pt-16">
            <div class="text-center">
                <div class="clear--sm"></div>
                <h2 class="pb-4" v-text="$t('RESET_PASSWORD_RESET')"></h2>
                <p class="py-1" v-html="$t('RESET_PASSWORD_ALL_SET')"></p>
            </div>

            <div class="clear--sm"></div>

            <div class="w-full max-w-xs mx-auto">

                <email-address-field
                    :is-valid="!errorHandler.has('email')"
                    :message="$t(errorHandler.get('email'))"
                    v-model="email"/>

                <password-field
                    :require-strong-password="true"
                    :is-valid="!errorHandler.has('password')"
                    :message="$t(errorHandler.get('password'))"
                    v-model="password"/>

                <password-field
                    :require-strong-password="true"
                    :is-valid="!errorHandler.has('password_confirmation')"
                    :message="$t(errorHandler.get('password_confirmation'))"
                    :label="$t('RESET_PASSWORD_CONFIRM')"
                    v-model="confirmPassword"/>

                <div class="text-center">
                    <submit-button @click="submitForm" v-html="$t('RESET_PASSWORD_UPDATE')"></submit-button>
                </div>
            </div>

            <div class="text-center">
                <div class="clear--sm"></div>
                <p class="py-1" v-html="$t('RESET_PASSWORD_SUPER_SECURE')"></p>
                <p class="py-1 mb-16" v-text="$t('RESET_PASSWORD_EG')"></p>
            </div>
    </section>
</template>

<script>
import { USER_TYPE } from '@/constants/Account';
import AuthService from '@/services/auth/AuthService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import PasswordService from '@/services/auth/PasswordService';
import PasswordField from '@/components/forms/fields/PasswordField';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import EmailAddressField from '@/components/forms/fields/EmailAddressField';

let passwordService = new PasswordService();
let authService = new AuthService();

export default {
    name: 'ResetPassword',
    props: {
        token: {
            type: String,
        },
        messageEmail: {
            type: String,
        },
    },
    data() {
        return {
            isFormProcessing: false,
            email: null,
            password: null,
            confirmPassword: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    mounted() {
        passwordService.validateResetPasswordToken(this.token, this.messageEmail)
            .catch(() => {
                this.$router.push({ name: 'home' });
            });
    },
    methods: {
        /**
         * Send required information to the backend to update password.
         *
         * @returns {void}
         */
        requestToUpdatePassword() {
            passwordService.requestToUpdatePassword(this.email, this.password, this.confirmPassword, this.token)
                .then(() => {
                    this.authenticateUser(this.email, this.password);
                })
                .catch((error) => {
                    this.errorHandler.setResponse(error.response.data);
                    this.isFormProcessing = false;
                });
        },

        /**
         * Authenticate user with API service.
         *
         * @param {String} email
         * @param {String} password
         *
         * @returns {void}
         */
        async authenticateUser(email, password) {
            this.$store.dispatch('auth/resetAuth');
            this.$store.dispatch('account/resetAccount');

            await authService.login(email, password);

            this.$store.dispatch('register/resetRegistrationProgress');
            this.$store.dispatch('auth/loginUser', USER_TYPE);

            this.$router.push({ name: 'account.dashboard' });
        },

        /**
         * On click submit the form.
         *
         * @returns {void}
         */
        submitForm() {
            setTimeout(() => {
                this.requestToUpdatePassword();
            }, 1000);
        },
    },
    components: {
        EmailAddressField,
        SubmitButton,
        PasswordField,
    },
};
</script>
